<template>
  <div class="p-6 flex flex-col gap-8 description-color">
    <AppDataProperty
      contentId="giftCards"
      @dataAvailable="
        data => {
          if (!data?.metaData?.cards) return
          cards = data?.metaData?.cards
        }
      "
      isComponent
    />
    <div class="font-bold text-white text-xl text-center">
      {{
        option.id == 'buy'
          ? $t('transactions.giftCardSelector.selectCardToBuyTitle')
          : $t('transactions.giftCardSelector.selectCardToSellTitle')
      }}
    </div>

    <div class="grid grid-cols-3 gap-4 max-h-[50dvh] overflow-auto">
      <div v-for="(card, i) in cardsToShow" :key="i">
        <div
          class="h-[9rem] flex flex-col border rounded-2xl ripple overflow-hidden"
          @click="selectCard(card)"
          :class="{
            'bg-primary-1000 !border-transparent': card.id !== selectedCard?.id,
            'bg-primary-700 border-primary': card.id == selectedCard?.id,
          }"
        >
          <div class="h-[6rem] w-full overflow-hidden">
            <img
              :src="card.image"
              class="scale-[1.1] w-full h-full object-cover"
              alt=""
            />
          </div>
          <div class="h-[3rem] flex flex-col items-center justify-center">
            <div class="text-center">{{ card.name }}</div>
          </div>
        </div>
      </div>
      <div v-for="(el, i) in new Array(Math.max(6-cardsToShow.length, 0)).fill('')" :key="i">
        <div
          class="h-[9rem] border border-dashed border-primary-900 flex flex-col rounded-2xl overflow-hidden"
          
        >
          <div class="h-[6rem] w-full overflow-hidden">
          </div>
          <div class="h-[3rem] flex flex-col items-center justify-center">
            <div class="text-center">&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
    <div class="buttonComponent mt-4" @click="confirmSelectedOption">
      {{ $t('transactions.giftCardSelector.continue') }}
    </div>
  </div>
</template>

<script>
import AppDataProperty from '@/components/appData/AppDataProperty.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TransactionOptionSelector',
  components: { AppDataProperty },
  props: {
    service: { type: Object, default: {} },
    option: { type: Object, default: {} },
  },
  data() {
    return {
      eventsIds: [],
      cards: [],
      selectedCard: {},
    }
  },
  mounted() {},
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    selectCard(card) {
      this.selectedCard = card
    },
    confirmSelectedOption() {
      if (!this.selectedCard.id) {
        this.$Events.dispatchEvent('toast_notification', {
          title: this.$t('transactions.giftCardSelector.selectCardNotifTitle'),
          body: this.$t('transactions.giftCardSelector.selectCardNotifBody'),
        })
        return
      }
      this.$emit('cardSelected', {
        ...this.selectedCard,
        isGiftCard: true,
        isBuying: this.selectedCard.metadata.isForBuying,
      })
    },
  },
  computed: {
    cardsToShow() {
      return this.cards.filter(card => {
        if (this.option.id == 'buy') return card.metadata.isForBuying
        return !card.metadata.isForBuying
      })
    },
  },
})
</script>
